import { useEffect, useState } from 'react';
import Icon from '../../../../component/Icon';
import { burger } from '../../../../assets/images/images';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Bars } from 'react-loader-spinner';

function ViewProduct() {
  const state = useSelector((state) => state.product);
  const [product, setProduct] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!state.backend.selectedProduct) {
      navigate(-2);
      return;
    }
    console.log(state.backend.selectedProduct)
    setProduct(state.backend.selectedProduct);
  }, [state.backend.selectedProduct]);

  if (!product)
    return (
      <div className='flex flex-col items-center justify-center min-h-[25rem]'>
        <Bars height={25} color='#3b82f6' margin='0 auto' />
        <h1 className=' text-sm text-gray-400 mt-2'>Please wait...</h1>
      </div>
    );
  return (
    <div>
      {/* HEADER */}
      <div className='flex items-center ml-6 gap-2 mb-4'>
        <Icon name='eye-solid' className='w-5 h-5 fill-greySecondary' />
        <h2 className='text-2xl font-[500] text-greySecondary'>View Product</h2>
      </div>
      {/* PRODUCT CREATED BY ... */}
      <div className='flex gap-4 ml-8 font-[300] mb-8 text-sm text-greySecondary'>
        <div className='flex items-center gap-2'>
          <h2 className='font-[400]'>Created By: </h2>
          <h3>
            {product.created_by?.firstname} {product.created_by?.lastname}
          </h3>
        </div>
        <div className='flex items-center gap-2'>
          <h2 className='font-[400]'>Modified By: </h2>
          <h3>Yashu Neupane</h3>
        </div>
        <div className='flex items-center gap-2'>
          <h2 className='font-[400]'>Modified Date: </h2>
          <h3>2022/03/12</h3>
        </div>
      </div>

      {/* DESCRIPTION */}
      <div className='flex gap-16 drop-shadow-xl w-[90%] mx-auto bg-white p-8'>
        {/* LEFT */}
        <div className='flex-1'>
          <ProductCard product={product} />
        </div>
        {/* RIGHT */}
        <div className='flex-1'>
          <h2 className='font-[500] uppercase text-darkPrimary mb-2 text-xl'>
            {product.title}
          </h2>
          <h3 className='font-Aclonica mb-8  font-[100] text-xs text-greySecondary'>
            Main Course
          </h3>
          <div className='bg-[#eee] rounded-lg p-4 '>
            <p className='text-sm text-greyPrimary'>{product.description}</p>
          </div>

          <Link
            to={`/admin/products/edit/${product.id}?`}
            className=' mt-4 inline-block bg-blue-500 p-2  rounded-md text-white'
          >
            <button className='flex gap-2 items-center'>
              <Icon name='edit' className='w-4 h-4 fill-white' />
              <h2 className='font-[600] text-sm'>Edit product</h2>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

function ProductCard(props) {
  return (
    <div className='rounded-lg overflow-hidden'>
      <div>
        <img
          src={burger}
          className='block w-full h-[15rem] object-cover'
          alt='product'
        />
      </div>
      {/* DESCRIPTION */}
      <div className='py-4 px-6 bg-[#eee] '>
        <h2 className='font-[700]'>Rs {props.product.price}</h2>
        <p className='text-sm text-greyPrimary'>{props.product.description}</p>
      </div>
    </div>
  );
}
export default ViewProduct;
